import PricingVariant from '~/api/entities/pricing/variant';
import PricingVariantGroup from '~/api/entities/pricing/variant/group';
import EntityFactory from '~/api/entities/base/factories/entity';

export default class PricingResult {
  list = [];

  listByRoute = [];

  filteredListByRoute = [];

  selectedDateUid = null;

  constructor (data) {
    this.list = data.result
      .map((item, index) => {
        return EntityFactory.createRow(PricingVariant, {
          ...item,
          dictionary: data.dictionary,
          index,
        });
      });

    const listByRoute = this.list
      .reduce((res, item) => {
        res[item.route.uid] = res[item.route.uid] || new PricingVariantGroup({ route: item.route });
        res[item.route.uid].addVariant(item);
        return res;
      }, {});

    this.listByRoute = Object.values(listByRoute)
      .map((item, index) => {
        return EntityFactory.createRow(PricingVariantGroup, {
          ...item,
          index,
        });
      });

    this.filteredListByRoute = this.listByRoute;
  }

  filter () {
    if (!this.selectedDateUid) {
      this.filteredListByRoute = this.listByRoute;
      return;
    }
    this.filteredListByRoute = this.listByRoute.filter(item => {
      return item.dateOptions.find(opt => opt.name === this.selectedDateUid);
    });
  }

  selectDate (value) {
    this.selectedDateUid = value;
    // this.listByRoute.forEach(item => item.expanded = false);
    if (!value) return;
    this.listByRoute
      .filter(item => item.dateOptions.find(opt => opt.name === value))
      .forEach(item => item.selectedDateUid = value);
  }

  quantityByDate (dateUid) {
    return this.list
      .filter(variant => variant.route.path.firstLeg.departure.date.dateUid === dateUid)
      .length;
  }

  clear () {
    this.list = [];
    this.listByRoute = [];
    this.filteredListByRoute = [];
    this.selectedDateUid = null;
  }

  findByRaids (raidsUid) {
    return this.list.find(variant => variant.raidsUid === raidsUid);
  }
};
